<main>
  <div class="as-central-container">
    <div class="close-mat-icon-container as-pointer">
      <mat-icon
        (click)="closeDownloadAppsBanner()"
        svgIcon="ic-close-green"
      ></mat-icon>
    </div>
    <div class="as-invite-modal">
      <div class="as-content-image-phone">
        <img
          class="as-image-phon-modal"
          src="assets/images/phone-modal-ne.png"
          alt=""
        />
      </div>
      <div class="as-container-info">
        <p class="as-font-20 as-font-w-700 as-text-title">
          {{ 'TRACKING.titleModalDonwload' | translate }}
        </p>
        <ul>
          <li class="as-font-medium as-font-16 as-font as-line-height-normal">
            {{ 'TRACKING.goon' | translate }}
          </li>
          <li class="as-font-medium as-font-16 as-font as-line-height-normal">
            {{ 'TRACKING.chat' | translate }}
          </li>
          <li class="as-font-medium as-font-16 as-font as-line-height-normal">
            {{ 'TRACKING.add' | translate }}
          </li>
          <li class="as-font-medium as-font-16 as-font as-line-height-normal">
            {{ 'TRACKING.receives' | translate }}
          </li>
        </ul>

        <div (click)="goRoute('appStore')" class="as-pointer as-download-app">
          <div class="as-from-container as-separation-stores">
            <p>{{ 'TRACKING.fromIphone' | translate }}</p>
            <img
              class="as-app-store"
              width="150"
              height="48"
              ngSrc="assets/images/app-store.png"
            />
          </div>
          <div
            (click)="goRoute('googlePlay')"
            class="as-pointer as-from-container"
          >
            <p>{{ 'TRACKING.fromAndroid' | translate }}</p>
            <img
              class="as-google-play"
              width="150"
              height="48"
              ngSrc="assets/images/google-play.png"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
